import { useMutation } from "@apollo/client/react";
import { UPDATE_TEMPLATE_SETTINGS } from "../../mutations/invoiceInterpretationTemplates/updateTemplateSettings";
import type { TemplateSettingsInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateTemplateSettings = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_TEMPLATE_SETTINGS,
    { onCompleted, onError },
  );

  const updateTemplateSettings = async ({
    input,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    input: TemplateSettingsInput;
  }) => {
    return mutation({
      variables: { templateId, clientIdentifier, input },
    });
  };

  return { updateTemplateSettings, loading, error, data };
};
